module.exports = __webpack_public_path__ + "media/images/top_fv-22f8eec93687d60fea56e9bcbd4a7e6a.png";